module.exports = __webpack_public_path__ + "static/media/phone-call-footer.e8d4ec14.svg";